import { Writable, writable } from "svelte/store";
import { OnboardingSessionStore } from "@onboarding2/svelte/Stores/OnboardingSessionStore";
import type { DistributorUser } from "@shared/types/Distributor";
import type { RetailerUser } from "@shared/types/User";

const store: Writable<RetailerUser | DistributorUser | null> = writable(null);

function userIsPopulated(user: any): user is RetailerUser | DistributorUser {
  return !!user?.id;
}

store.subscribe(user => {
  if (userIsPopulated(user) && !user.hasOwnProperty("currently_onboarding")) {
    OnboardingSessionStore.destroyOnboardingSession();
  }
});

export default store;
